import { render, staticRenderFns } from "./edit-protocol.vue?vue&type=template&id=1d3e14ae"
import script from "./edit-protocol.vue?vue&type=script&lang=ts"
export * from "./edit-protocol.vue?vue&type=script&lang=ts"
import style0 from "./edit-protocol.vue?vue&type=style&index=0&id=1d3e14ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports